import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]
  static values = { fieldName: String }

  connect() {
    this._outsideClickHandler = (event) => {
      // Don't close if clicking on a toggle button
      if (event.target.closest('[data-action*="review-comments#toggleComments"]')) {
        return
      }

      // Find all visible comment containers (both field and step comments)
      const visibleContainers = document.querySelectorAll('.field-comments__container:not(.hidden), .step-comments__container:not(.hidden)')

      visibleContainers.forEach(container => {
        const fieldCommentsElement = container.closest('.field-comments, .step-comments')
        if (fieldCommentsElement && !fieldCommentsElement.contains(event.target)) {
          container.classList.add('hidden')
        }
      })
    }
    document.addEventListener('click', this._outsideClickHandler)

    // Listen for successful form submit events to clear forms and hide containers
    this._onSubmitEnd = (event) => {
      if (event.detail.success) {
        const form = event.target
        const textarea = form.querySelector('textarea')

        // Clear the textarea for all comment forms
        if (textarea) {
          textarea.value = ''
        }

        // Hide containers for step/field comments
        const container = form.closest('.field-comments__container, .step-comments__container')
        if (container) {
          container.classList.add('hidden')
        }
      }
    }
    document.addEventListener('turbo:submit-end', this._onSubmitEnd)
  }

  disconnect() {
    document.removeEventListener('click', this._outsideClickHandler)
    document.removeEventListener('turbo:submit-end', this._onSubmitEnd)
  }

  toggleComments(event) {
    event.preventDefault()

    const fieldName = event.currentTarget.dataset.fieldName

    // Find the corresponding comment container for this field
    // Look for the field-comments element with the matching field name that's closest to the clicked element
    let commentElement = null

    // First, try to find a comment element within the same parent container as the clicked element
    const parentContainer = event.currentTarget.closest('.step-details-component__field, .step-details-component__nested-field, .step-details-component__array-nested-field, .step-details-component__account-field, .step-details-component__row')
    if (parentContainer) {
      commentElement = parentContainer.querySelector(`[data-review-comments-field-name-value="${fieldName}"]`)
    }

    // If not found in the same container, fall back to finding the first one in the document
    if (!commentElement) {
      commentElement = document.querySelector(`[data-review-comments-field-name-value="${fieldName}"]`)
    }

    if (commentElement) {
      // Look for both field-comments and step-comments containers
      const commentContainer = commentElement.querySelector('.field-comments__container, .step-comments__container')

      if (commentContainer) {
        // Close all other open comment containers first
        const allVisibleContainers = document.querySelectorAll('.field-comments__container:not(.hidden), .step-comments__container:not(.hidden)')
        allVisibleContainers.forEach(container => {
          if (container !== commentContainer) {
            container.classList.add('hidden')
          }
        })

        // Toggle the current container
        commentContainer.classList.toggle("hidden")

        // Focus on textarea when showing
        if (!commentContainer.classList.contains("hidden")) {
          const textarea = commentContainer.querySelector('.field-comments__textarea, .step-comments__textarea')
          if (textarea) {
            setTimeout(() => textarea.focus(), 100)
          }
        }
      }
    }
  }
}
